import { palette } from '@client/theme/colors';
import { typography } from '@client/theme/typography';
import { radii, theme } from '@client/theme/constants';
import { shadows } from '../shadows';
import type { ThemeOptions } from '@mui/material';

const Menu: ThemeOptions['components'] = {
  MuiMenuItem: {
    styleOverrides: {
      root: {
        ...typography.body1,
        color: palette.text.secondary,
        backgroundColor: palette.grey[50],
        padding: theme.spacing(1),
        minHeight: theme.spacing(4),

        '&:hover, &.Mui-focusVisible': {
          backgroundColor: palette.grey[200],
        },

        '&.Mui-selected': {
          backgroundColor: palette.grey[200],

          '& > span:last-of-type, & > span:only-of-type': {
            fontWeight: 600,
          },
        },
      },
    },
  },
  MuiMenu: {
    styleOverrides: {
      paper: {
        borderRadius: radii.medium,
        boxShadow: shadows[4],
        marginTop: theme.spacing(1),
      },
    },
  },
};

export default Menu;
